import type { Message, RagSource } from '../types/chat';

/** Normalize `rag_sources` from PostgREST (jsonb) or legacy string JSON; accept minor key variants. */
export function normalizeMessageRagSources(m: Message): Message {
  const raw = m.rag_sources as unknown;
  if (raw == null) {
    return { ...m, rag_sources: null };
  }

  let parsed: unknown = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return { ...m, rag_sources: null };
    }
  }

  if (!Array.isArray(parsed)) {
    return { ...m, rag_sources: null };
  }

  const rag_sources: RagSource[] = parsed
    .filter((item): item is Record<string, unknown> => item !== null && typeof item === 'object')
    .map((item) => {
      const id = item.markdown_file_id ?? item.markdownFileId;
      const title = item.title;
      if (id == null || String(id).length === 0) return null;
      return {
        markdown_file_id: String(id),
        title:
          typeof title === 'string' && title.trim().length > 0 ? title.trim() : 'Untitled',
      };
    })
    .filter((x): x is RagSource => x != null);

  return {
    ...m,
    rag_sources: rag_sources.length > 0 ? rag_sources : null,
  };
}
